






































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { pages } from '@/core/paging/paging.service';
import urlHelperService from '@/services/url/urlHelper.service';

@Component
export default class Paginator extends Vue {
	@Prop({ type: Array, required: true })
	data!: any[];

	@Prop({ type: Number, default: 1 })
	startPage!: number;

	currentPage: number = 1;

	@Prop({ type: Number, default: 5 })
	pageSize!: number;

	@Prop({ type: Boolean, default: false })
	topNavigation!: boolean;

	pages: number[] = [];

	get noOfPages(): number {
	    return Math.ceil(this.data.length / this.pageSize);
	}

	goto(page: number): void {
	    this.currentPage = Math.max(0, page);
	    this.pages = pages(this.currentPage, this.noOfPages);
	    urlHelperService.setPage(page);
	}

	public nextPage() {
	    this.goForwardEnabled && (this.currentPage++);
	    urlHelperService.setPage(this.currentPage);
	}

	public prevPage() {
	    this.goBackEnabled && (this.currentPage--);
	    urlHelperService.setPage(this.currentPage);
	}

	get goBackEnabled(): boolean {
	    return this.currentPage > 1;
	}

	get goForwardEnabled(): boolean {
	    return this.currentPage < this.noOfPages;
	}

	get currentData() {
	    const start = (this.currentPage - 1) * this.pageSize;
	    const end = start + this.pageSize;
	    return this.data.slice(start, end);
	}

	setup(validateMaxPage: boolean) {
	    let currentPage = urlHelperService.getPage() || this.startPage;
	    if (validateMaxPage && currentPage > this.noOfPages) {
	        currentPage = this.noOfPages || 1;
	        urlHelperService.setPage(currentPage);
	    }

	    this.currentPage = currentPage;
	    this.pages = pages(this.currentPage, this.noOfPages);
	}

	get pagingEnabled() {
	    return this.data.length > this.pageSize;
	}

	handleKeyDown(e: KeyboardEvent) {
	    if (this.isRightArrow(e)) {
	        this.nextPage();
	    } else if (this.isLeftArrow(e)) {
	        this.prevPage();
	    }
	}

	isRightArrow(event: KeyboardEvent) {
	    return event && (event.key === 'ArrowRight' || event.key === 'Right');
	}

	isLeftArrow(event: KeyboardEvent) {
	    return event && (event.key === 'ArrowLeft' || event.key === 'Left');
	}

    @Watch('data')
	onDataChange() {
	    this.setup(true);
	}

    created() {
        this.setup(false);
        document.addEventListener('keydown', this.handleKeyDown);
    }

    destroyed() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
}
